import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Row, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonShow";
import IdentificationCard from "components/Common/IdentificationCard";

const DocumentationGeneraleDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState("details");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  document.title = "Documentation générale | Détails";

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails Documentation générale"
            ) : (
              <span className="placeholder col-3" style={{ height: "1em" }}></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/documentation_generales/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) navigate(`${backUrl}/forbidden`);
      if (response.status === 500) navigate(`${backUrl}/error`);
      if (response.status === 203) navigate(`${backUrl}/error404`);
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const editSuccess = localStorage.getItem("editSuccess");
    if (editSuccess === "true") {
      toast.success("Mise à jour réussie");
      localStorage.removeItem("editSuccess");
    }
  }, []);

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/documentation_generales/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Documentation générale
                      </Link>
                      <i className="bx bx-caret-right"></i>
                      {!loading ? (
                        data?.sil || data?.detail_documentation_generale?.["Identification"]?.["Nom"] || `#${id}`
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end gap-2">
                      {data?.can_edit ? (
                        <Link
                          to={`${backUrl}/documentation_generales/${id}/edit`}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      {data?.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/documentation_generales/${id}`}
                          redirectUrl={`${backUrl}/documentation_generales`}
                        />
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <Row>
                          <Col sm="12">
                            {data?.detail_documentation_generale?.["Identification"] ? (
                              <IdentificationCard
                                title="Identification"
                                details={data.detail_documentation_generale["Identification"]}
                              />
                            ) : (
                              <IdentificationCard
                                title="Identification"
                                details={{
                                  Nom: data?.nom,
                                  Catégorie: data?.categories_document,
                                  Type: data?.types_document,
                                  Année: data?.annee,
                                  Fichier: data?.fichier,
                                }}
                              />
                            )}
                          </Col>
                        </Row>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={400} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default DocumentationGeneraleDetail;
